module.exports = __webpack_public_path__ + "img/sidebar-border-line.18053da2.svg";